import PropTypes from 'prop-types';
import React, {useMemo, useRef} from 'react';
import {Modal, Button, Icon} from 'semantic-ui-react';
import * as Yup from 'yup';

import QrCode from './QrCode';

import styles from './QrCodeModal.module.scss';

function QrCodeModal({siteUrl, onClose}) {
  const qrRef = useRef();
  const urlSchema = Yup.string().url();

  // Unique key that updates when siteUrl changes
  const qrKey = useMemo(() => Date.now(), []);

  urlSchema.validate(siteUrl).catch(_error => {
    console.warn('QrCodeModal: Invalid siteUrl: ', siteUrl);
    return null;
  });

  const handleDownload = () => {
    qrRef.current?.download(); // Call the method exposed by QrCode
  };

  return (
    <Modal
      className={styles.QRCodeModal}
      size="small"
      onClose={onClose}
      closeIcon
      open
      style={{
        padding: '0.5rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: 'auto',
        maxWidth: 'none',
      }}
    >
      <Modal.Header>
        QR Code for{' '}
        <a href={siteUrl} target="_blank" rel="noreferrer">
          {siteUrl}
        </a>
      </Modal.Header>
      <Modal.Content
        style={{
          padding: '1rem',
          display: 'flex',
          gap: '1rem',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <QrCode key={qrKey} url={siteUrl} ref={qrRef} />
      </Modal.Content>

      <Modal.Actions style={{padding: '0.5rem 1rem'}}>
        <div className={styles.ActionButtons}>
          <Button
            primary
            icon
            labelPosition="right"
            className={styles.ActionButton}
            onClick={() => {
              handleDownload();
            }}
          >
            <Icon name="download" />
            Download
          </Button>
        </div>
      </Modal.Actions>
    </Modal>
  );
}

QrCodeModal.propTypes = {
  siteUrl: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

export default QrCodeModal;
